import React from 'react';
import ReactDOM from 'react-dom/client';
import { bootstrapBrowserBackBlockAfterReload } from './common/browserHistoryNavigation';
import './index.css';
import './styles/UI-kit/styles.scss';
import './styles/designsystem-brand-overrides.scss';
import './locals/index'
import {
  applyBrandIdentityToDocument,
  applyThemeAndColorsToDocument,
  getCachedBranding,
} from './common/branding';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from './components/NotistackPlus';
import { LicenseInfo } from '@mui/x-license-pro';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

bootstrapBrowserBackBlockAfterReload();

const cachedBranding = getCachedBranding();
if (cachedBranding?.brandIdentity) {
  applyBrandIdentityToDocument(cachedBranding.brandIdentity);
}
if (cachedBranding?.themeAndColors) {
  applyThemeAndColorsToDocument(cachedBranding.themeAndColors);
}

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string)
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <SnackbarProvider maxSnack={1} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
    <SnackbarUtilsConfigurator />
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </SnackbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
